export default {
  baseSiteURL: process.env.BASE_SITE_URL,
  intercomRecruiterAppId: process.env.INTERCOM_RECRUITER_APP_ID,
  intercomHackerAppId: process.env.INTERCOM_HACKER_APP_ID,
  csrfTokenKey: 'doselectcsrf',
};

export const DEVICE_LOCALSTORAGE_KEY = 'devices';

export const DEVICE_KIND = {
  MIC: 'mic',
  WEBCAM: 'webcam',
  SPEAKER: 'speaker',
};

export const KIND_TO_MEDIA_KIND = {
  [DEVICE_KIND.MIC]: 'audioinput',
  [DEVICE_KIND.WEBCAM]: 'videoinput',
  [DEVICE_KIND.SPEAKER]: 'audiooutput',
};

export const UBA_EVENT_NAMES = {
  errorLog: 'errorLog',
  proctoringLog: 'proctoringLog',
  proctoringTracker: 'proctoringTracker',
  aboutToStartView: 'aboutToStartView',
  aboutToStartClick: 'aboutToStartClick',
  allProblemView: 'allProblemView',
  allProblemClick: 'allProblemClick',
  problemView: 'problemView',
  problemClick: 'problemClick',
  popUpView: 'popUpView',
  popUpClick: 'popUpClick',
  candidateFeedbackView: 'candidateFeedbackView',
  chatbotClick: 'chatbotClick',
};

export const PAGE_NAME = {
  allProblems: 'All Problems Page',
  declaration: 'Declaration Page',
  doSelectInstruction: 'DoSelectInstruction Page',
  error404: 'Error 404 Page',
  error: 'Error Page',
  feedback: 'Feedback Page',
  help: 'Help Page',
  postlanding: 'Post Landing Page',
  problem: 'Problem Page',
  systemCheck: 'System Check Page',
  assessmentInstruction: 'Assessment Instruction Page',
  aiInterview: 'AI Interview Page',
};

export const POPUP_NAME = {
  webcamNotDetected: 'WebcamNotDetected',
  microphoneNotDetected: 'MicrophoneNotDetected',
  manualSubmit: 'ManualSubmit',
  autoSubmit: 'AutoSubmit',
  fullScreenEnabled: 'FullScreenEnabled',
  realTimeFeedback: 'realTimeFeedback',
  uploadVideoOrDiscard: 'uploadVideoOrDiscard',
  audioProblemMoveAway: 'audioProblemMoveAway',
  exitAssessment: 'exitAssessment',
};

export const SERVICE_NAME = 'do-test-interface';

// since we have the image in our repo and calculating
// image size will have extra logic thats we had the
// image size as constant
export const NETWORK_DOWNLOAD_IMG_SIZE_IN_KB = 471234;

export const OFFLINE_DURATION_LOCALSTORAGE_KEY = 'offline-duration-in-seconds';

export const TEST_START_TIME_SESSIONSTORAGE_KEY = 'TEST_START_TIME';

export const DPJ_TEST_TYPE_SESSIONSTORAGE_KEY = 'DPJ_TEST_TYPE';

export const OFFLINE_LAST_START_TIME_LOCALSTORAGE_KEY =
  'doselect_last_offline_start_time';
export const OFFLINE_TIMESTAMP_LOCALSTORAGE_KEY = 'doselect_offline_timestamp';

export const ONE_MINUTE_IN_MILI_SECONDS = 60000;

export const AUTO_SUBMIT_REASONS = {
  SYSTEM_TIME_MISMATCH: "User's system time mismatch with actual time",
  BROWSER_TOLERANCE_VIOLATION: 'Browser Tolerance Violation',
  TEST_TIME_EXPIRY: 'Test Time Expiry',
  WEBCAM_ERROR: 'webcamError',
};

export const SYSTEM_TIME_TRACKING_INTERVAL_IN_MILLISECONDS = 120000;

export const SYSTEM_TIME_MISMATCH_TOAST_MESSAGE =
  'We have detected a mismatch in system time!';

export const SYSTEM_TIME_MISMATCH_ALERT_MESSAGE =
  'Your system time is incorrect. Please update it to the current time and refresh the page.';

export const INTERNET_DISCONNECTION_MESSAGE =
  'Action cannot be completed. Please check your internet connection.';

export const TIME_INTERVAL_BETWEEN_SAVE = {
  DJP: 60000, // 60s
  PBE: 900000, // 15 mins
  PFE: 900000,
  PFS: 900000,
  PBT: 900000,
  PBD: 900000,
};

export const ENV_SETUP_TIME_DEFAULT = 120; // deafult
export const ENV_SETUP_RETRY_TIME = 180;

export const ENV_SETUP_INFRA_RETRY_SECONDS = 10;

export const INFRA_PROVISIONING_START_TIME_SESSIONSTORAGE_KEY =
  'INFRA_PROVISIONING_START_TIME_SESSIONSTORAGE_KEY';
export const INFRA_PROVISIONING_DETAILS_SESSIONSTORAGE_KEY =
  'INFRA_PROVISIONING_DETAILS_SESSIONSTORAGE_KEY';

export const ENV_SETUP = {
  TITLE_TEXT: 'Environment Setup',
  ENV_READY_TEXT: 'Your environment is ready',
  PROVISION_SERVER_TEXT: 'Provisioning servers for the <%= productTypeSmall %>',
  RESOURCE_ALLOCATION_FAILED_TEXT: 'Resource Allocation Failed',
  MAX_CAPACITY_TEXT: "We're at capacity right now, Please retry in sometime",
  WAIT_TEXT: 'Please wait',
  LONGER_TIME_TEXT:
    "It's taking longer than expected. We'll get there as fast as we can",
};

export const POD_BASED_CREATE_SERVER_ERROR_MSG =
  'This question is currently live hence cannot be edited, please change it to draft and try again.';

export const IFRAME_LOAD_MSG_FROM_IFRAME = 'iframeLoaded';

export const TEST_END_TIME_LOCALSTORAGE_KEY = '_END_TIME_LOCALSTORAGE_KEY';

export const IFRAME_LOAD_TEXT = {
  DJP: 'Your Jupyter Environment is Loading.',
  PBE: 'Your Environment is Loading.',
  PFE: 'Your Environment is Loading.',
  PFS: 'Your Environment is Loading.',
  PBT: 'Your Environment is Loading.',
  PBD: 'Your Environment is Loading.',
};

export const EVALUATION_STATE = {
  IDLE: 'IDLE',
  LOADING: 'LOADING',
  EVALUATING: 'EVALUATING',
  EVALUATED: 'EVALUATED',
  ERROR: 'ERROR',
  MAL_PRACTICE_ERROR: 'MAL_PRACTICE_ERROR',
  ABORT: 'ABORT',
};

export const NETWORK_OFFLINE_TEXT =
  'Action cannot be completed. Please check your internet connection.';

export const SECTION_SUBMIT_API_VERSION = '2';

export const TEST_SUBMIT_RETRY_COUNTER = 3;

export const TEST_SUBMIT_RETRY_DELAY_IN_MILLISECONDS = 0;

export const UBA_INFRA_PROVISIONING_ERROR_VERBOSE = 'error:infra-provisioning';

export const DEFAULT_ASSESSMENT_TYPE = 'test';

export const FEEDBACK_PAGE_REDIRECTION_INTERVAL = 3000;

export const DEFAULT_REDIRECTION_URL = `${window.location.protocol}://www.naukri.com`;

export const TEST_TYPE_SESSION_STORAGE_KEY = 'testType';

export const TEST_TYPE = {
  QUIZ: 'quiz',
};

export const POD_BASED_PROBLEM_TYPE = {
  DJP: 'DJP',
  PFE: 'PFE',
  PBE: 'PBE',
  PFS: 'PFS',
  PBT: 'PBT',
  PBD: 'PBD',
};

export const POD_BASED_IFRAME_TITLE = {
  DJP: 'jupyter-notebook',
  PFE: 'vscode-pod',
  PBE: 'vscode-pod',
  PFS: 'vscode-pod',
  PBT: 'vscode-pod',
  PBD: 'vscode-pod',
};

export const POD_BASED_META_INFO_KEY = {
  DJP: 'datascience_jupyter_data',
  PBP: 'project_based_problem_data',
  PFE: 'project_based_problem_data',
  PBE: 'project_based_problem_data',
  PFS: 'project_based_problem_data',
  PBT: 'project_based_problem_data',
  PBD: 'project_based_problem_data',
};

export const POD_BASED_TESTCASE_PROPERTIES = {
  'AC/OK': {
    color: '#2ecc71',
    testcaseIcon: 'fa fa-check',
    statusIcon: 'fa fa-check-circle-o',
    statusText: 'accepted',
  },

  NC: {
    color: '#f34235',
    testcaseIcon: 'fa fa-times',
    statusIcon: 'fa fa-times-circle-o',
    statusText: 'rejected',
  },
};

export const ICON_NAMES = {
  faAngleUp: 'fa-angle-up',
  faAngleDown: 'fa-angle-down',
};

export const PLURALIZE_VALUE = {
  0: '',
  1: ' second',
  other: ' seconds',
};

export const DEFAULT_GROUP_LENGTH = 10;

export const CACHED_PROBLEM_GROUP_LENGTH = 60;
export const POD_BASED_OPEN_IN_EDITOR_KEY = {
  stub: 'problem_stub_s3_location',
  solution: 'problem_solution_s3_location',
};

export const UPLOAD_FAILED_QUESTIONS = `Upload failed! Please retry by clicking "Upload" or "Record Again" for these questions:`;

export const AUDIO_UPLOAD_FAILED_TEXT = `Audio upload failed! Please retry by clicking "Upload" or "Record Again".`;

export const AUDIO_UPLOAD_SUCCESS_TEXT = 'Upload Completed!';

export const NO_AUDIO_FILE_ERROR_MESSAGE =
  'Oops! It looks like the audio file is either broken or missing. Please re-record your answer.';

export const MIC_PERMISSION_DENIED =
  'Please grant microphone permission and reload the page';

export const SECURE_BROWSER_CONST = {
  BROWSER_NAME: `Secure Browser`,
  BROWSER_VERSION: '1',
  LOG_INFO_EVENT: 'secure-browser-info',
  LOG_INFO_ERR: 'secure-browser-error',
  EXIT_APP_LABEL_TXT:
    ' By checking this box, I agree to allow Doselect to close all running applications',
  COMMAND_STATUS: {
    RUNNING: 'running',
    NOT_EXECUTED: 'notExecuted',
    IN_PROGRESS: 'inProgress',
    SUCCESS: 'success',
  },
  CONFIGURE: 'CONFIGURE',
  EXIT_KISOK_MODE: 'EXIT_KISOK_MODE',
  EVENTS_TO_ELECTRON: {
    SET_TEST_URL: 'SET_TEST_URL',
    CONFIGURE_DISPLAY: 'CONFIGURE_DISPLAY',
    BLOCK_GESTURES: 'BLOCK_GESTURES',
    NOTIFICATION: 'NOTIFICATION',
    GET_SUB_SYSTEM_INFO: 'GET_SUB_SYSTEM_INFO',
    SEND_LOGS: 'SEND_LOGS',
    GET_MACHINE_UUID: 'GET_MACHINE_UUID',
  },

  EXIT_ASSESSMENT_POPUP: {
    TITLE: 'Exit Application',
    SUB_TEXT: 'Are you sure you want to exit?',
    SUB_TEXT_INFO: `Your responses will be saved, and you can re-enter before your
    time expires.`,
  },
};

export const DJP_HEALTH_CHECK_INTERVAL_MS = 5000;

export const DJP_HEALTH_CHECK_MAX_ATTEMPTS = 30;

export const DJP_POD_HEALTH_CONTACT_SUPPORT_MESSAGE =
  'Your notebook environment is not responding after multiple checks. Please contact support@doselect.com for assistance.';
